// A document named by its number, as a real link to it (#/doc/<kind>/<id>): opens in place, in a new
// tab, by keyboard, and can be copied. Without a document it is just the words.

import type { ReactNode } from 'react';
import { docHref, type DocRef } from './doc-link.ts';
import './doc-link.css';

export function DocLink({ doc, children }: { doc: DocRef | null | undefined; children: ReactNode }) {
  if (!doc) return <>{children}</>;
  return (
    <a className="doc-link" href={docHref(doc)}>
      {children}
    </a>
  );
}
